import { ReactComponent as DefaultUserIcon } from '@/assets/default-user-avatar.svg';
import { twMerge } from 'tailwind-merge';
import { AvatarProps } from './avatar.types';

function AvatarPlaceholder({ className, round }: AvatarProps) {
  return (
    <div className={twMerge('h-full w-full object-cover', className, round && 'rounded-full')}>
      <div className="flex h-full w-full flex-col items-center justify-center rounded-full">
        <DefaultUserIcon className="h-full w-full text-ph-primary-violet" />
      </div>
    </div>
  );
}

export default AvatarPlaceholder;
